import script from "./basketball.vue?vue&type=script&setup=true&name=BasketballMatch&lang=js"
export * from "./basketball.vue?vue&type=script&setup=true&name=BasketballMatch&lang=js"

import "./basketball.vue?vue&type=style&index=0&id=26122654&scoped=true&lang=css"
import "./basketball.vue?vue&type=style&index=1&id=26122654&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26122654"]])

export default __exports__